import { http, HttpResponse } from 'msw'

import type { CreateChainAgencyContactDataParams } from '../../agency/create-chain-agency-contact-data'

interface CreateChainAgencyContactDataPathParams {
  alphaId: string
}

interface CreateChainAgencyContactDataPayload {
  contactData: CreateChainAgencyContactDataParams
}

export const mockCreateChainAgencyContactData = http.post<
  CreateChainAgencyContactDataPathParams,
  CreateChainAgencyContactDataPayload
>(
  '/my-business/api/agency/v1/agency-chains/:alphaId/contact-data',
  async ({ request }) => {
    const requestBody = await request.json()

    if (requestBody.contactData.companyEmail === 'error@error.com.br') {
      const error = {
        message: 'E001',
        detail: 'Algum erro',
      }

      return HttpResponse.json({ error }, { status: 400 })
    }

    return HttpResponse.json(null, { status: 200 })
  },
)
